// src/utils/msalAuth.js

import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

// Create a standalone MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);
let initialized = false;

export const login = async () => {
    try {
      if (!initialized) {
        await msalInstance.initialize();
        initialized = true;
      }

  
      const loginResponse = await msalInstance.loginPopup();
      const userEmail = loginResponse?.idTokenClaims?.preferred_username;
      const userName = loginResponse?.idTokenClaims?.name;
      localStorage.setItem("myemail", userEmail.toLowerCase());
      localStorage.setItem("userName", userName);
      
  
      return loginResponse;
    } catch (error) {
      console.error("Login failed", error);
      throw error;
    }
  };
